import { render, staticRenderFns } from "./SettingsMetadata.vue?vue&type=template&id=7982240c&scoped=true"
import script from "./SettingsMetadata.vue?vue&type=script&lang=js"
export * from "./SettingsMetadata.vue?vue&type=script&lang=js"
import style0 from "./SettingsMetadata.vue?vue&type=style&index=0&id=7982240c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7982240c",
  null
  
)

export default component.exports